import { type AudiCalculationModuleSpecsFragment } from '../../../../api/fragments/AudiCalculationModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import AudiCalculationModuleTabAuthorization from './AudiCalculationModuleTabAuthorization';
import AudiCalculationModuleTabMain from './AudiCalculationModuleTabMain';
import { HeaderTabs } from './types';

type AudiCalculationModuleInnerPageProps = {
    activeTab: HeaderTabs;
    module: AudiCalculationModuleSpecsFragment;
    openAudiCalculationSettingDrawer: () => void;
    permissions: Pick<PermissionValues, 'hasUpdatePermission'>;
};

const AudiCalculationModuleInnerPage = ({
    activeTab,
    module,
    openAudiCalculationSettingDrawer,
    permissions,
}: AudiCalculationModuleInnerPageProps) => {
    switch (activeTab) {
        case HeaderTabs.MainDetails:
            return (
                <AudiCalculationModuleTabMain
                    module={module}
                    openAudiCalculationSettingDrawer={openAudiCalculationSettingDrawer}
                    permissions={permissions}
                />
            );

        case HeaderTabs.Authorization:
            return <AudiCalculationModuleTabAuthorization module={module} />;

        default:
            return null;
    }
};

export default AudiCalculationModuleInnerPage;
